{
  "TelephoneserverLabel": "Telephone Server:",
  "PartitionsLabel": "Partition(s):",
  "ScopeGroupsLabel": "Scope Group(s):",
  "AnyScopeGroupsLabel": "[Any Scope Group]",
  "NAME": "ScopeFiltering",
  "ScopeFiltering_SectionHeader": "Scope Filtering"
}